import React, { createContext, useContext, useState } from "react";
import { AuthProvider } from "react-oidc-context";
import { getConfigVariable } from "../config/config";

const OidcContext = createContext();

export const OidcProviderContext = ({ children }) => {
    const [provider, setProvider] = useState(null);
    const providers = getConfigVariable("AUTH_CONFIG");
    const selectProvider = (providerName) => {
        setProvider({
            ...providers[providerName],
            onSigninCallback() {
                window.history.replaceState({}, document.title, window.location.pathname);
            },
        });
    };
    const loginMode = window.localStorage.getItem("login-mode");
    const providerName = loginMode && loginMode !== "" ? loginMode : "sso";
    const providerToUse = {
        ...providers[providerName],
        onSigninCallback() {
            window.history.replaceState({}, document.title, window.location.pathname);
        },
    };

    return (
        <OidcContext.Provider value={{ provider, selectProvider }}>
            {providerToUse ? <AuthProvider {...providerToUse}>{children}</AuthProvider> : children}
        </OidcContext.Provider>
    );
};

export const useOidcProvider = () => useContext(OidcContext);
